import { render, staticRenderFns } from "./VehicleSensorData.vue?vue&type=template&id=2fc2984c&scoped=true&"
import script from "./VehicleSensorData.vue?vue&type=script&lang=js&"
export * from "./VehicleSensorData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc2984c",
  null
  
)

export default component.exports